import {
    FETCH_CHATS_REQUEST,
    FETCH_CHATS_SUCCESS,
    FETCH_CHATS_FAILURE,
    FETCH_CONVERSATIONS_REQUEST,
    FETCH_CONVERSATIONS_SUCCESS,
    FETCH_CONVERSATIONS_FAILURE,
    SEND_QUESTION_REQUEST,
    SEND_QUESTION_SUCCESS,
    SEND_QUESTION_FAILURE,
    SEND_CONVERSATION_QUESTION_REQUEST,
    SEND_CONVERSATION_QUESTION_SUCCESS,
    SEND_CONVERSATION_QUESTION_FAILURE,
} from './actions';

const initialState = {
    chatResponse: {
        topic: '',
        answer: '',
        conversation_id: '',
        olc_link: '',
        loading: false,
        error: null,
    },
    chats: {
        items: [],
        page: null,
        page_size: null,
        page_count: null,
        items_size: null,
        total_items: null,
        loading: false,
        error: false,
    },
    conversationResponse: {
        id: null,
        topic: '',
        created_at: '',
        user_id: null,
        chat_request: '',
        chat_response: '',
        session_id: '',
        olc_link: '',
        loading: false,
        error: null,
    },
    conversations: {
        byChatId: {},
    },
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
    // Chats
    case SEND_QUESTION_REQUEST:
        return {
            ...state,
            chatResponse: {
                loading: true,
                error: null,
            },
        };

    case SEND_QUESTION_SUCCESS:
        return {
            ...state,
            chatResponse: {
                loading: false,
                error: null,
            },
        };

    case SEND_QUESTION_FAILURE:
        return {
            ...state,
            chatResponse: {
                loading: false,
                error: action.payload.error,
            },
        };

    case FETCH_CHATS_REQUEST:
        return {
            ...state,
            chats: {
                loading: true,
                error: false,
            },
        };

    case FETCH_CHATS_SUCCESS:
        return {
            ...state,
            chats: {
                items: action.payload.items,
                page: action.payload.page,
                page_size: action.payload.page_size,
                page_count: action.payload.page_count,
                items_size: action.payload.items_size,
                total_items: action.payload.total_items,
                loading: false,
                error: false,
            },
        };

    case FETCH_CHATS_FAILURE:
        return {
            ...state,
            chats: {
                ...state.chats,
                loading: false,
                error: action.payload,
            },
        };

    // Conversations
    case FETCH_CONVERSATIONS_REQUEST:
        return {
            ...state,
            conversations: {
                ...state.conversations,
                byChatId: {
                    ...state.conversations.byChatId,
                    [action.payload.id]: {
                        data: state.conversations.byChatId[action.payload.id]?.data || [],
                        loading: false,
                        error: null,
                    },
                },
            },
        };

    case FETCH_CONVERSATIONS_SUCCESS:
        return {
            ...state,
            conversations: {
                ...state.conversations,
                byChatId: {
                    ...state.conversations.byChatId,
                    [action.payload.id]: {
                        data: action.payload.conversations,
                        loading: false,
                        error: null,
                    },
                },
            },
        };

    case FETCH_CONVERSATIONS_FAILURE:
        return {
            ...state,
            conversations: {
                ...state.conversations,
                byChatId: {
                    ...state.conversations.byChatId,
                    [action.payload.chatId]: {
                        ...state.conversations.byChatId[action.payload.chatId],
                        loading: false,
                        error: action.payload.error,
                    },
                },
            },
        };

    // Send Conversation Question
    case SEND_CONVERSATION_QUESTION_REQUEST:
        return {
            ...state,
            conversationResponse: {
                loading: true,
                error: null,
            },
        };

    case SEND_CONVERSATION_QUESTION_SUCCESS: {
        return {
            ...state,
            conversationResponse: {
                id: action.payload.id,
                topic: action.payload.topic,
                created_at: action.payload.created_at,
                user_id: action.payload.user_id,
                chat_request: action.payload.chat_request,
                chat_response: action.payload.chat_response,
                session_id: action.payload.session_id,
                loading: false,
                error: null,
            },
        };
    }

    case SEND_CONVERSATION_QUESTION_FAILURE:
        return {
            ...state,
            conversationResponse: {
                loading: false,
                error: action.payload.error,
            },
        };

    default:
        return state;
    }
};

export default reducer;
